module.exports = __webpack_public_path__ + "media/images/congrats-4f19d13e.svg";